import React from "react";
import styled from "styled-components";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";

const StyledLocationWrapper = styled.div`
  width: 98%;
  height: 141px;
  margin: 15px 0;
`;

const StyledHeading = styled.div`
  width: 140px;
  height: 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 23px;
  font-weight: bolder;
`;

const StyledText = styled.p`
  font-size: 15px;
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
  color: ${(props) => (props.color ? props.color : "#4D4C4C")};
  padding: ${(props) => (props.padding ? props.padding : "0")};
`;

const StyledCoordinates = styled.div`
  width: 186px;
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 23px;
`;
const StyledBox = styled.div`
  width: 145px;
  height: 33px;
  border: 0.5px solid #c7c7c7;
  border-radius: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export default function Location(props) {
  return (
    <StyledLocationWrapper>
      {/* <StyledHeading>
        <StyledLocationIcon />
        <StyledText>LOCATION ONE</StyledText>
      </StyledHeading> */}
      <StyledHeading>
        <FormControlLabel
          control={
            <Checkbox
              icon={<LocationOnOutlinedIcon />}
              checkedIcon={<LocationOnIcon />}
              name="checkedH"
              checked={'true'}
            />
          }
          label={`Location ${props.id}`}
        />
      </StyledHeading>

      <StyledCoordinates>
        <StyledText bold>Lat</StyledText>
        <StyledBox>
          <StyledText padding={"0 0 0 9px"} color={"#2B4877"} bold>
            {props.Lat}
          </StyledText>
        </StyledBox>
      </StyledCoordinates>

      <StyledCoordinates>
        <StyledText bold>Lon</StyledText>
        <StyledBox>
          <StyledText padding={"0 0 0 9px"} color={"#2B4877"} bold>
            {props.Long}
          </StyledText>
        </StyledBox>
      </StyledCoordinates>
    </StyledLocationWrapper>
  );
}
